import api from "../../../api/index";

export function postAssignOrder(payload) {
  return api.post("/updateSystemStatusCodeMapping", payload);
}
export function getAllCouriers(query) {
  const encodedQuery = encodeURIComponent(query);
  return api.get(`/getAllCpInfo?tenantId=${encodedQuery}`);
}
export function getSystemStatusCode(query) {
  const encodedQuery = encodeURIComponent(query);
  return api.get(`/getAllSystemStatusCodes?tenantId=${encodedQuery}`);
}
export function getAllData({ tenantId, courier, isMapped }) {
  const encodedTenantId = encodeURIComponent(tenantId);
  const encodedCourier = encodeURIComponent(`"${courier}"`);
  const encodedIsMapped = encodeURIComponent(isMapped);
  return api.get(
    `/getStatusMappingWithSystemStatusCodes?tenantId=${encodedTenantId}&cpCodes=[${encodedCourier}]&isMapped=${encodedIsMapped}`
  );
}
export function updateSystemStatusCodeEntries(payload) {
  return api.put("/updateSystemStatusCodeEntries", payload);
}
